var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonCard',{staticStyle:{"padding":"5%"}},[_c('v-row',{staticClass:"mb-10",attrs:{"dense":"","align":"center"}},[_c('v-col',{staticStyle:{"text-align":"center"},attrs:{"cols":"12"}},[_c('span',{staticClass:"titulo-header"},[_vm._v("Servicios Inbound")])])],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('BuscarLead')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }